/* eslint func-style: "off" */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  // Actions
  FETCH_INTERNAL_ADMINS, HANDLE_SORT_CHANGE,
  // Action Creators
  fetchInternalAdminsSucceeded, fetchInternalAdminsFailed,
  handleSortChange
} from './InternalAdminsTab.ducks';
import apiClient from 'helpers/apiClient';
import get from 'lodash/get';

const fetchInternalAdmins = function* () {
  try {
    // Fetch users with Internal Admin role
    const payload = yield call(apiClient, '/api/users/internal-admins', {
      method: 'GET'
    });
    yield put(fetchInternalAdminsSucceeded(payload));
  } catch (e) {
    const error = get(e, 'body.error', 'Failed to fetch Internal Admins');
    yield put(fetchInternalAdminsFailed(error));
  }
};

const handleSortChangeSaga = function* (action) {
  // Sort is handled in the component, but this saga is here for consistency
  // and in case we need to fetch sorted data from the server in the future
  yield put(handleSortChange(action.payload.sortBy, action.payload.sortOrder));
};

const fetchInternalAdminsSaga = function* () {
  yield takeLatest(FETCH_INTERNAL_ADMINS, fetchInternalAdmins);
};

const handleSortChangeSagaWatcher = function* () {
  yield takeLatest(HANDLE_SORT_CHANGE, handleSortChangeSaga);
};

const sagas = function* () {
  yield all([
    fork(fetchInternalAdminsSaga),
    fork(handleSortChangeSagaWatcher)
  ]);
};

export default sagas;
